export default "__VITE_ASSET__rdF9CtzJ__"